import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const PageHelmet = ({ title, description, noIndex = false, schema }) => {
  const canonicalUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}`
      : '';
  const formattedTitle = title?.includes('Yoda Safety Services')
    ? title
    : `${title} | Yoda Safety Services`;

  return (
    <Helmet>
      <title>{formattedTitle} | Yoda Safety Services</title>

      <meta name="description" content={description} />

      {noIndex && <meta name="robots" content="noindex, follow" />}

      {!noIndex && canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

PageHelmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  noIndex: PropTypes.bool,
  schema: PropTypes.object,
};

export default PageHelmet;
